// extracted by mini-css-extract-plugin
module.exports = {"tabList":"Tabs_tabList__R9KFi"};